import { useTranslation } from '@gimlite/common';
import { useStoreUIV1, Wizard } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import { ArticleCode, ProductsParameters } from '../../client/graphql';
import {
  DefaultContractBaseWizard,
  DefaultContractDetailsWizard,
} from '../../common/defaultValue/wizard';
import { CredentialType } from '../../common/mapper/credential.mapper';
import {
  ContractBaseFormType,
  ContractDetailsFormType,
} from '../../form/contract-create/contract-create.form';
import { ProductFormType } from '../../form/product/product.form';
import { ConfirmationStep } from './steps/confirmation/confirmation.step';
import { ContractStep } from './steps/contract/contract.step';
import { ParkerStep } from './steps/parker/parker.step';
import { ProductStep } from './steps/product/product.step';
import { SummaryStep } from './steps/summary/summary.step';

export type CreateNewSingleContractWizardContext = {
  parkingId: string | null;
  product: {
    id: ProductFormType.Data.ProductId | null;
    period: number | null;
    credentials: CredentialType.GlobalName[];
    duration: Pick<ProductsParameters, 'durationUnit' | 'durationValue'> | null;
    articleCodes: Array<ArticleCode>;
  };
  contractBase: ContractBaseFormType.Data.ContractBase;
  contractDetails: ContractDetailsFormType.Data.ContractDetails;
  contractSearchSelect: ContractDetailsFormType.Data.CurrentSearchContractValue | null;
  credentials: ContractDetailsFormType.Data.Credentials;
  addFakeQRCODE: boolean;
};

export const CreateNewSingleContractWizard = observer(() => {
  const { t, lang } = useTranslation();
  const { WizardStore } = useStoreUIV1();

  const { parkingId } = WizardStore?.selected?.store;

  return (
    <Wizard<CreateNewSingleContractWizardContext>
      config={{
        title: t(`createANewSingleContract`),
      }}
      data={{
        defaultContext: {
          parkingId,
          product: {
            id: null,
            period: null,
            credentials: [],
            duration: null,
            articleCodes: [],
          },
          contractBase: DefaultContractBaseWizard({
            t,
            lang,
          }),
          contractDetails: DefaultContractDetailsWizard({
            t,
            lang,
          }),

          contractSearchSelect: null,
          credentials: {
            actived: [],
            desactived: [],
            context: 'wizardNewContract',
          },
          addFakeQRCODE: false,
        },
      }}
      handleEvent={{
        done: async (data) => {
          console.log('done', { data });
        },
        clear: () => {
          console.log('CLEAR');
        },
        close: () => {
          WizardStore.clear();
        },
      }}
    >
      <Wizard.Item config={{ title: t('product'), component: ProductStep }} />
      <Wizard.Item config={{ title: t('contract'), component: ContractStep }} />
      <Wizard.Item config={{ title: t('parker'), component: ParkerStep }} />
      <Wizard.Item
        config={{ title: t('confirmation'), component: ConfirmationStep }}
      />
      <Wizard.Item config={{ title: t('summary'), component: SummaryStep }} />
    </Wizard>
  );
});
